import { createFileRoute } from "@tanstack/react-router";

import { StudioPage } from "@/components/landing/studio-page";

export const Route = createFileRoute("/studio")({
  component: StudioPage,
});
